// web-staking-estimator-frontend/src/services/pdfService.js

/**
 * Download a PDF blob from the backend without opening a popup
 * @param {string} estimateId - The estimate ID to fetch PDF for
 * @param {string} filename - The filename to save as
 * @throws {Error} If the fetch fails
 */
export async function downloadPdfBlob(estimateId, filename) {
  if (!estimateId) {
    throw new Error("No estimate ID provided");
  }

  const response = await fetch(
    `/api/estimates/${encodeURIComponent(estimateId)}/pdf`,
    {
      method: "GET",
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  // Extract filename from response headers if available
  let serverFilename = null;
  const contentDisposition = response.headers.get("Content-Disposition");
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=["']?([^"';\n]+)/);
    if (filenameMatch && filenameMatch[1]) {
      serverFilename = filenameMatch[1];
    }
  }
  // Fallback: custom header (survives proxy stripping of Content-Disposition)
  if (!serverFilename) {
    serverFilename = response.headers.get("X-PDF-Filename");
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  // Priority: server filename > parameter filename > default
  anchor.download = serverFilename || filename || `estimate-${estimateId}.pdf`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
